export function clinicDetailsArray(clinic, t, infoElevation) {
    return [
      {
        title: t("Country"),
        value: t(clinic?.country),
      },
      {
        title: t("City"),
        value: clinic?.city,
      },
      {
        title: t("ZipCode"),
        value: clinic?.zipCode,
      },
      {
        title: t("StreetAddress"),
        value: clinic?.streetAddress,
      },
      {
        title: t("Email"),
        value: clinic?.email,
      },
      {
        title: t("PhoneNumber"),
        value: clinic?.phoneNumber,
      },
      {
        title: t("LinkToClinicPage"),
        value: clinic?.url,
      },
    ];
  }
  